import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getBOFormation(idFormation) {
    const response = await axios.get("/api/gestion/formations/" + idFormation);
    return response.data;
  },
  async getBOFormations() {
    const response = await axios.get("/api/gestion/formations");
    return response.data;
  },
  async getFormationsSUAIO(idCampus) {
    const response = await axios.get(
      "/api/suaio/formations/referent/campus/" + idCampus
    );
    return response.data;
  },
  async getFormationsEnseignant() {
    const response = await axios.get("/api/enseignant/formations/enseignant");
    return response.data;
  },
  async getFormationsScolarite(idCampus) {
    const response = await axios.get("/api/scolarite/formations/" + idCampus);
    return response.data;
  },
  async getTypesDiplomes() {
    const response = await axios.get("/api/typesDiplomes");
    return response.data;
  },
  async getFormationsParTypeDiplome(idTypeDiplome) {
    const response = await axios.get(
      "/api/typesDiplomes/" + idTypeDiplome + "/formations"
    );
    return response.data;
  },
  async getFormation(idFormation) {
    const response = await axios.get("/api/formations/" + idFormation);
    return response.data;
  },
  async updateFormation(formation) {
    const response = await axios.put(
      "/api/gestion/formations/" + formation.id,
      formation
    );
    return response.data;
  },
  async ajoutFormation(formation) {
    const response = await axios.post("/api/admin/formations", formation);
    return response.data;
  },
  async supprimerFormation(idFormation) {
    const response = await axios.delete("/api/admin/formations/" + idFormation);
    return response.data;
  },
  async getFormations() {
    const response = await axios.get("/api/formations");
    return response.data;
  },
  async getFormationsCsv() {
    const response = await axios.get("/api/gestion/csv/formations");
    return response.data;
  },
  async getFormationsREO(idTypeDiplome) {
    const response = await axios.get("/api/formationsREO/" + idTypeDiplome);
    return response.data;
  },
  async getNiveauxFormations() {
    const response = await axios.get("/api/formations/niveaux");
    return response.data;
  },
};
